export default {
  getShopList: {
    method: 'get',
    url: 'shop'
  },
  addShop: {
    method: 'post',
    url: 'shop'
  },
  reviseShop: {
    method: 'put',
    url: 'shop'
  },
  deleteShop: {
    method: 'delete',
    url: 'shop'
  },
  remoteShop: {
    method: 'post',
    url: 'shop/login'
  },
  getShopType: {
    method: 'get',
    url: 'shop/type'
  },
  getShopAccountList: {
    method: 'get',
    url: 'shop/account'
  },
  reviseShopAccount: {
    method: 'post',
    url: 'shop/account'
  },
  giveAuth: {
    method: 'post',
    url: 'shop/auth'
  },
  getAuthList: {
    method: 'get',
    url: 'shop/auth'
  },
  updateUser: {
    method: 'post',
    url: 'shop/user-update'
  }
}
